module.exports = __webpack_public_path__ + "static/img/10.ef937cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/10.png
// module id = jGSo
// module chunks = 0